<template lang="pug">
  div#app.container
    navbar
    router-view
</template>

<script>
export default {
  name: 'App',
  components: {
    navbar: () => import('./components/navbar'),
  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue